export default {
  getUsuarios(state) {
    return state.usuarios;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getUserData(state) {
    return state.userData;
  },
  getTermsConditionsUser(state) {
    return state.termsConditions;
  },
};
